import { AxiosRequestConfig } from 'axios';
import { requester } from '../config';

export type LogInParams = { username: string; password: string };

export type AuthResponse = {
  message: string;
  status: number;
  usertoken: string;
};

export const logIn = (
  { username, password }: LogInParams,
  config: AxiosRequestConfig = {}
) =>
  requester.post<AuthResponse>(
    '/login',
    {
      username,
      mode: 'normal'
    },
    {
      ...config,
      headers: {
        password,
        ...config.headers
      }
    }
  );

export const register = (forminfo: any, config: AxiosRequestConfig = {}) =>
  requester.post(
    '/register',
    { forminfo, register: 1 },
    { ...config, alertErrorMessage: true }
  );

export const makeResetPasswordRequest = (
  forminfo: any,
  config: AxiosRequestConfig = {}
) =>
  requester.post(
    '/request_password_reset',
    { forminfo },
    { alertMessage: true, ...config }
  );

export const resetPassword = (forminfo: any, config: AxiosRequestConfig = {}) =>
  requester.post(
    '/reset_password',
    { forminfo, platform: 'web' },
    { alertMessage: true, ...config }
  );
